import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

const theme = {
  primary: '#ffc601',
  secondary: '#5a3d91',
  accent: '#9C27b0',
  info: '#00CAE3',
  blue: '#97dddd',
  'blue-light': '#dcefef',
  bluecolor: '#6acdef',
  grey: '#b5bdc4',
  'grey-light': '#cccccc',
  'grey-mid': '#878787',
  'light-grey': '#a4a4a4',
  light: '#f4f4f4',
  dark: '#222',
  danger: '#cc0808',
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
